import { render, staticRenderFns } from "./DetailConfigDatasetGroupAdd.vue?vue&type=template&id=72bcf12e"
import script from "./DetailConfigDatasetGroupAdd.vue?vue&type=script&lang=js"
export * from "./DetailConfigDatasetGroupAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports